module.exports = __webpack_public_path__ + "img/03-fuwu.ed1428a0.png";